import { render, staticRenderFns } from "./NavigationBreadcrumb.vue?vue&type=template&id=322197cb&scoped=true&"
import script from "./NavigationBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./NavigationBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBreadcrumb.vue?vue&type=style&index=0&id=322197cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322197cb",
  null
  
)

export default component.exports